import React from 'react';
import moment from 'moment';
import { useField } from 'formik';

import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const FieldDayPicker = ({
  className = '',
  ...props
}) => {
  const [, { value }, { setTouched, setValue }] = useField(props);

  return (
    <div>
      <div className={`
        ${className}
        h-auto w-auto d-inline-block pt-3
      `}>
        <DayPicker
          initialMonth={
            value?.[0] || new Date()
          }
          selectedDays={value.map((d) => new Date(d))}
          onDayClick={(date, { selected }) => {
            setTouched();

            const d = moment(date);
            let draft = [...value];

            if (selected) {
              draft = draft.filter((s) => !d.isSame(s, 'd'));
            } else {
              draft.push(d.toDate());
              draft.sort((a, b) => a - b);
            }

            setValue(draft);
          }}
        />
      </div>
    </div>
  );
};

export default FieldDayPicker;
